/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, BigNumberish } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { TetherToken } from "./TetherToken";

export class TetherTokenFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _initialSupply: BigNumberish,
    _name: string,
    _symbol: string,
    _decimals: BigNumberish,
    overrides?: Overrides
  ): Promise<TetherToken> {
    return super.deploy(
      _initialSupply,
      _name,
      _symbol,
      _decimals,
      overrides || {}
    ) as Promise<TetherToken>;
  }
  getDeployTransaction(
    _initialSupply: BigNumberish,
    _name: string,
    _symbol: string,
    _decimals: BigNumberish,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      _initialSupply,
      _name,
      _symbol,
      _decimals,
      overrides || {}
    );
  }
  attach(address: string): TetherToken {
    return super.attach(address) as TetherToken;
  }
  connect(signer: Signer): TetherTokenFactory {
    return super.connect(signer) as TetherTokenFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TetherToken {
    return new Contract(address, _abi, signerOrProvider) as TetherToken;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_initialSupply",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_decimals",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "AddedBlackList",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newAddress",
        type: "address",
      },
    ],
    name: "Deprecate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_blackListedUser",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_balance",
        type: "uint256",
      },
    ],
    name: "DestroyedBlackFunds",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Issue",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "feeBasisPoints",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "maxFee",
        type: "uint256",
      },
    ],
    name: "Params",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "Pause",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Redeem",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "RemovedBlackList",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "Unpause",
    type: "event",
  },
  {
    inputs: [],
    name: "MAX_UINT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "_totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_evilUser",
        type: "address",
      },
    ],
    name: "addBlackList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "_spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "remaining",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "allowed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "balances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "basisPointsRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_upgradedAddress",
        type: "address",
      },
    ],
    name: "deprecate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "deprecated",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_blackListedUser",
        type: "address",
      },
    ],
    name: "destroyBlackFunds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_maker",
        type: "address",
      },
    ],
    name: "getBlackListStatus",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "isBlackListed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "issue",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "maximumFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "redeem",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_clearedUser",
        type: "address",
      },
    ],
    name: "removeBlackList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newBasisPoints",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "newMaxFee",
        type: "uint256",
      },
    ],
    name: "setParams",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "upgradedAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
